import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ className = '', onClick, asLink = true, height = 100 }) => {
  const logoImage = (
    <img 
      src="/logo.png" 
      alt="Glaciert AI" 
      style={{ height: `${height}px`, width: 'auto' }}
      className="object-contain"
    />
  );

  if (asLink) {
    return (
      <Link 
        to="/" 
        onClick={onClick} 
        className={`cursor-pointer hover:opacity-70 transition-all duration-300 flex-shrink-0 flex items-center ${className}`}
      >
        {logoImage}
      </Link>
    );
  }

  return (
    <div 
      onClick={onClick}
      className={`cursor-pointer hover:opacity-70 transition-all duration-300 flex-shrink-0 flex items-center ${onClick ? 'cursor-pointer' : ''} ${className}`}
    >
      {logoImage}
    </div>
  );
};

export default Logo;
